import type { Submit1Body, Submit2Body } from '../../server/src/types'

const URL = 'https://asia-northeast3-fortynamo.cloudfunctions.net/snuhServer'

export const makeUUID = () => {
  return fetch(`${URL}/makeUUID`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(
    res =>
      res.json() as Promise<
        { success: true; data: string } | { success: false }
      >,
  )
}

export const submit1 = (body: Submit1Body) => {
  return fetch(`${URL}/submit1`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(res => res.json() as Promise<{ success: boolean }>)
}

export const submit2 = (body: Submit2Body) => {
  return fetch(`${URL}/submit2`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(res => res.json() as Promise<{ success: boolean }>)
}
